import {SysRole as Role} from './sys.role';

export class SysAccount {
    constructor(){
        this.IsLogin = false;
        this.IsAdmin = false;
       this.Departments = new Array<any>();
       this.img = "";
       this.AppVersion="0.0.0.0";
       this.IsUpdate=true;
       this.Qrcode=null;
       this.BuType="";
    }
    /**
     * 是否登录成功
     */
    IsLogin: boolean;
    /**
     * 登录者ID
     */
    Id: string;
    /**
     * 登录者姓名
     */
    DisplayName: string;
    /**
     * 是否首页
     */
    HomeUrl: string;
    /**
     * 员工编号
     */
    CustomerID:string;
    /**
     * 是否管理员
     */
    IsAdmin: boolean;
    /**
     * 最后一次登录时间
     */
    LastPageUpdateDate: string;
    Limit: any;
    /**
     * 登录名
     */
    LoginName: string;
    Departments: Array<any>;
    RoleIds: Array<any>;
    Roles: Array<Role>;
    /**
     * 获取图像信息
     */
    img: string;
    /**
     * 创建时间
     */
    CreateTime: string;
    /**
     * 获取手机唯一识别码
     */
    uuid: string;
    /**
     * 手机号码
     */
    phone: string;
        /**
     * 用户头像
     */
    Pic: string;

    /**
     * 用户等级code
     */
    GradeCode?: string;

    /**
     * 用户等级name
     */
    GradeName?: string;
    /**
     * 是否保级
     */
    IsRelegationTime?: boolean;
    /**
     * APP版本号 default：0.0.0.0
     */
    AppVersion?:string;
    /**
     * 是否立即更新默认true
     */
    IsUpdate:boolean;
    /**
     * 用户二维码
     */
    Qrcode:string;
    /**
     * 用户微信id
     */
    QYWXId:string;
    /**
     * 用户微信id类型
     */
    QYWXIdType:string;
    /**
     * 判断当前用户是NTS还是Retail
     */
    BuType:string;
}